import { Icon } from '@iconify/react';
import parser from 'html-react-parser';
import React, { useState } from 'react';
import SectionHeading from './SectionHeading';

export default function Bio({ data }) {
  const [loading, setLoading] = useState(false);

  const handleDownload = (event) => {
    setLoading(true);

    // Delay for 3 seconds before reverting to the original icon
    setTimeout(() => {
      setLoading(false);
    }, 1500);
  };

  const { sectionHeading, nationality, nationalFlag, languagesKnown, birthDay, resume } = data;
  return (
    <section className="section no-top-padding bio-section" id="bio">
      <div className="container">
        <SectionHeading
          miniTitle={sectionHeading.miniTitle}
          title={sectionHeading.title}
        />
        <div className="row gy-3">
          {/* Nationality */}
          <div className="col-lg-6">
              <div className="review-box">
                <div className="r-box">
                  <label>Nationality</label>
                  <h3>{nationality} <img src={nationalFlag} alt='Inidan National Flag'></img></h3>
                </div>
              </div>
          </div>
          {/* Place */}
          {/* <div className="col-sm-6 col-lg-4">
              <div className="review-box">
                <div className="r-box">
                  <label>Place</label>
                  <h3>{place}</h3>
                </div>
              </div>
          </div> */}
          {/* Blood Group */}
          {/* <div className="col-sm-6 col-lg-4">
              <div className="review-box">
                <div className="r-box">
                  <label>Blood Group</label>
                  <h3>{bloodGroup}</h3>
                </div>
              </div>
          </div> */}
          {/* Birthday */}
          <div className="col-lg-6">
              <div className="review-box">
                <div className="r-box">
                  <label>Birthday</label>
                  <h3>{birthDay}</h3>
                </div>
              </div>
          </div>
          {/* Birth Place */}
          {/* <div className="col-sm-6 col-lg-4">
              <div className="review-box">
                <div className="r-box">
                  <label>Birth Place</label>
                  <h3>{birthPlace}</h3>
                </div>
              </div>
          </div> */}
          {/* Religion */}
          {/* <div className="col-sm-6 col-lg-4">
              <div className="review-box">
                <div className="r-box">
                  <label>Religion</label>
                  <h3>{religion}</h3>
                </div>
              </div>
          </div> */}
          {/* Languages Known */}
          <div className="col-12">
              <div className="review-box">
                <div className="r-box">
                  <label>Languages Known</label>
                  <h3>{parser(languagesKnown)}</h3>
                </div>
              </div>
          </div>

        </div>
        <a
          href={resume}
          download
          className={`px-btn white mt-4 ${loading ? "disabled" : ""}`}
          onClick={handleDownload}
          style={{ pointerEvents: loading ? "none" : "auto" }}
        >
          {loading ? (
            <>
              <span>Downloading Resume</span> &nbsp;&nbsp;&nbsp;{" "}
              <div className="spinner-border text-light me-2" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </>
          ) : (
            <>
              <span>Download My Resume</span>{" "}
              <i>
                <Icon icon="bi:file-earmark-arrow-down" />
              </i>
            </>
          )}
        </a>
      </div>
      
    </section>
  );
}
